import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './base';
import { Observable, of } from 'rxjs';
import { tap, finalize, share } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FetchDataService extends BaseService {

  private cache: any = <any>{};
  private cachedObservable: Observable<any> = <Observable<any>>{};

  constructor(private http: HttpClient) {
    super();
  }

  getByUrl(url, isRefresh: boolean = false): Observable<any> {
    let observable: Observable<any>;
    if (this.cache[url] && !isRefresh) {
      observable = of(this.cache[url]);
    }  else if (this.cachedObservable[url] && !isRefresh) {
      observable = this.cachedObservable[url];
    } else {
      this.cachedObservable[url] = this.http.get<any[]>(this.baseUrl + url)
        .pipe(
          tap(res => this.cache[url] = res),
          share(),
          finalize(() => this.cachedObservable[url] = null)
        );
      observable = this.cachedObservable[url];
    }
    return observable;
  }

  getPaginatedPostData(url, filter : any) {
    return this.http.post<any>(this.baseUrl + url, filter);
  }

  getData(url) {
    return this.http.get<any>(this.baseUrl + url);
  }

  getPublicIPCloudId(param : any) {
    return this.http.post<any>(this.baseUrl + 'CloudData/Azure/GetPublicIPCloudId', param);
  }
}
